import { useParams } from "react-router-dom";

const LEGAL_CONTENT = {
  terms: {
    title: "Terms of Service",
    body: "Terms of service content will be provided by Geminii's legal team. For questions, contact hello@geminii-ai.com.",
  },
  privacy: {
    title: "Privacy Policy",
    body: "Privacy policy content will be provided by Geminii's legal team. For questions, contact hello@geminii-ai.com.",
  },
  dpa: {
    title: "Data Processing Addendum",
    body: "Data processing addendum content will be provided by Geminii's legal team. For questions, contact hello@geminii-ai.com.",
  },
};

export default function LegalPage() {
  const { page } = useParams();
  const content = LEGAL_CONTENT[page] || { title: "Legal", body: "Page not found." };

  return (
    <div className="min-h-screen" data-testid={`legal-page-${page}`}>
      <section className="pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24">
          <h1 className="font-display font-bold text-3xl sm:text-4xl text-white mb-8">{content.title}</h1>
          <div className="text-geminii-muted leading-relaxed text-sm">
            <p>{content.body}</p>
          </div>
          <div className="mt-12 text-xs text-geminii-dim">
            Last updated: February 2026
          </div>
        </div>
      </section>
    </div>
  );
}
